module.exports = __webpack_public_path__ + "img/album14_11.914cc524.jpg";